import * as React from 'react';
import { AnalyticsTrigger } from '@core-front/analytics';
import PropsChecker from '@core-front/props-checker';
const ANIMATION_WAVE_DELAY = 100;
const ANIMATION_IN_DURATION = 300;
const ANIMATION_OUT_DURATION = 400;
const OptionCardOldCore = (props) => {
    return (React.createElement(PropsChecker, { componentName: "OptionCard", componentProps: props, defaultValueName: "defaultChecked", valueName: "checked", onChangeNames: "onChange", isComponentDisabled: props.disabled },
        React.createElement(AnalyticsTrigger, { trigger: { callback: 'onChange', id: `Option - ${props.id}` } },
            React.createElement(OptionCardCoreInner, Object.assign({}, props)))));
};
export class OptionCardCoreInner extends React.Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
        this.directionTimeout = 0;
        this.waveTimeout = 0;
        this.onChange = () => {
            if (this.inputRef.current) {
                const isChecked = this.inputRef.current.checked;
                const nextChecked = this.props.inputType === 'radio' ? true : !isChecked;
                if (this.props.disabled || (this.props.inputType === 'radio' && isChecked)) {
                    return;
                }
                if (typeof this.props.checked === 'undefined') {
                    this.setState({
                        checked: nextChecked,
                    });
                }
                if (this.props.onChange) {
                    this.props.onChange(nextChecked);
                }
            }
        };
        this.state = {
            animationActive: false,
            animationDirection: 'in',
            checked: props.defaultChecked || false,
        };
    }
    componentDidMount() {
        if (this.props.isInvalid && typeof this.props.index !== 'undefined') {
            this.startWaveAnimation();
        }
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isInvalid && this.props.isInvalid) {
            this.startWaveAnimation();
        }
        else if (prevProps.isInvalid && !this.props.isInvalid) {
            this.endAnimation();
            this.clearTimeouts();
        }
    }
    componentWillUnmount() {
        this.clearTimeouts();
    }
    clearTimeouts() {
        if (this.directionTimeout) {
            window.clearTimeout(this.directionTimeout);
        }
        if (this.waveTimeout) {
            window.clearTimeout(this.waveTimeout);
        }
    }
    get isChecked() {
        return this.props.onChange && typeof this.props.checked !== 'undefined' ? this.props.checked : this.state.checked;
    }
    BEM() {
        const classArray = ['option-card-old', `option-card-old--input-${this.props.inputType}`];
        if (this.props.color) {
            classArray.push('option-card-old--' + this.props.color);
        }
        if (this.props.type) {
            classArray.push('option-card-old--' + this.props.type);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        if (this.props.badgeTop || this.props.type === 'recommended') {
            classArray.push('option-card-old--badge-top');
        }
        if (this.props.isInvalid) {
            classArray.push('option-card-old--error');
        }
        if (this.state.animationActive) {
            classArray.push('is-animating');
        }
        if (this.state.animationDirection) {
            classArray.push('option-card-old--animate-' + this.state.animationDirection);
        }
        return classArray.join(' ');
    }
    renderBadgeTop() {
        const isRecommendedType = this.props.type === 'recommended';
        const Badge = this.props.components.BadgeTop || this.props.components.Badge;
        if ((typeof this.props.badgeTop === 'boolean' || !this.props.badgeTop) && !isRecommendedType) {
            return;
        }
        let badgeProps = {
            icon: isRecommendedType ? '#star' : '',
            purpose: (isRecommendedType && 'recommended') || undefined,
            text: this.props.recommendedLabel || undefined,
        };
        if (typeof this.props.badgeTop !== 'boolean' && this.props.badgeTop) {
            badgeProps = Object.assign(Object.assign({}, badgeProps), this.props.badgeTop);
        }
        return (React.createElement("div", { className: "option-card-old__badge-top-wrapper" },
            React.createElement("div", { className: "option-card-old__badge-top-wrapper-inner" },
                React.createElement(Badge, Object.assign({}, badgeProps)))));
    }
    renderCheckedBadge() {
        const { Badge } = this.props.components;
        return (React.createElement("div", { className: "option-card-old__checked-badge-wrapper" },
            React.createElement("div", { className: "option-card-old__checked-badge-inner" },
                React.createElement(Badge, { className: "option-card-old__checked-badge", icon: "#check", purpose: "selected", text: this.props.checkedLabel }))));
    }
    startWaveAnimation() {
        if (this.props.isInvalid && typeof this.props.index !== 'undefined') {
            this.waveTimeout = window.setTimeout(() => {
                this.startAnimation();
            }, this.props.index * ANIMATION_WAVE_DELAY);
        }
    }
    startAnimation() {
        this.setState({
            animationActive: true,
            animationDirection: 'in',
        }, () => {
            this.triggerFadeIn();
        });
    }
    endAnimation() {
        this.setState({
            animationActive: false,
            animationDirection: 'idle',
        });
    }
    triggerFadeIn() {
        this.directionTimeout = window.setTimeout(() => {
            this.setState({
                animationDirection: 'out',
            }, () => {
                this.triggerFadeOut();
            });
        }, ANIMATION_IN_DURATION);
    }
    triggerFadeOut() {
        this.directionTimeout = window.setTimeout(() => {
            this.endAnimation();
        }, ANIMATION_OUT_DURATION);
    }
    render() {
        const onClick = () => this.onChange();
        const { Icon } = this.props.components;
        return (React.createElement("div", { className: this.BEM() },
            React.createElement("input", Object.assign({}, this.props.input, { value: this.props.value, type: this.props.inputType, ref: this.inputRef, onChange: this.onChange, checked: this.isChecked, defaultChecked: undefined, disabled: this.props.disabled, id: this.props.id, className: "option-card-old__input", "aria-invalid": this.props.isInvalid })),
            React.createElement("label", { htmlFor: this.props.id, className: "option-card-old__label" }, this.props.labelText),
            React.createElement("div", { className: "option-card-old__body", onClick: onClick },
                this.props.tagTopContent && this.props.tagTopContent,
                this.renderBadgeTop(),
                React.createElement("div", { className: "option-card-old__elements" },
                    this.props.showIndicator && (React.createElement("span", { className: "option-card-old__indicator" }, this.props.inputType === 'checkbox' && React.createElement(Icon, { modifiers: "#check", className: "option-card-old__indicator-icon" }))),
                    this.props.children),
                this.renderCheckedBadge())));
    }
}
OptionCardCoreInner.defaultProps = {
    value: 'on',
};
export default OptionCardOldCore;
